import { useQueryClient } from '@tanstack/react-query';

import { toast } from 'sonner';

import { usePaymentController } from '@/entities/payment/model';

import { useUpdatePaymentDocs, useUploadHook } from '../model';
import { ComplianceFormSubmit } from './ComplianceModal';
import { UploadBar } from './UploadBar';

export const SpeedUpBar: React.FC<{
  paymentId?: string;
  variant?: 'dashboard' | 'transaction';
  onAdd?: () => void;
}> = ({ paymentId, onAdd, variant = 'dashboard' }) => {
  const queryClient = useQueryClient();
  const { payment, isLoading: isPaymentLoading } =
    usePaymentController(paymentId);
  const { uploadDoc, isLoading: isUploadLoading } = useUploadHook();
  const { updatePaymentDocs, isPending: isUpdateDocsPending } =
    useUpdatePaymentDocs();

  const onFormSubmit: ComplianceFormSubmit = async ({ files, data }) => {
    if (payment) {
      try {
        const attachments = await Promise.all(
          files.map(({ file, customFileName }) =>
            uploadDoc(file, customFileName),
          ),
        );
        await updatePaymentDocs({
          id: payment.id,
          note: data?.comment || "",
          attachments,
        });
        await queryClient.invalidateQueries({ queryKey: ['payments-list'] });
        await queryClient.invalidateQueries({ queryKey: ['txs-list'] });
        onAdd?.()
        toast.success('Purpose of payment added');
      } catch (e) {
        toast.error('Upload error');
        throw new Error('upload err');
      }
    }
  };

  const isSubmitting = isUploadLoading || isUpdateDocsPending;
  return (
    <UploadBar
      payment={payment}
      isPaymentLoading={isPaymentLoading}
      title="Speed up your transfer"
      subtitle="Add payment purpose"
      modalTitle="We need some information"
      modalSubtitle="Kindly clarify the detailed purpose of payment"
      buttonText="Add"
      onFormSubmit={onFormSubmit}
      isSubmitting={isSubmitting}
      requestIdFallback={payment?.id}
      className={variant === 'transaction' ? 'mb-1 bg-base-300' : 'bg-base-300'}
    />
  );
};
